export default __webpack_public_path__ + "static/media/arrow-fold-en.c92285c6.svg";